import DOMPurify from 'dompurify'

/**
 * Sanitizes an HTML string by allowing only specific tags and attributes.
 * @param html The HTML string to be sanitized.
 * @returns The sanitized HTML string.
 */
export default function sanitizedHtml(html: string) {
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR: [
      // Universal
      'id',
      'class',
      'style',
      'title',
      'lang',
      'dir',
      'tabindex',
      'hidden',
      'accesskey',
      'contenteditable',
      'draggable',
      'spellcheck',
      'translate',
      // Links & navigation
      'href',
      'target',
      'rel',
      'download',
      'hreflang',
      'type',
      // Media
      'src',
      'srcset',
      'sizes',
      'alt',
      'width',
      'height',
      'loading',
      'decoding',
      'crossorigin',
      'usemap',
      'ismap',
      // Audio / Video
      'controls',
      'autoplay',
      'loop',
      'muted',
      'preload',
      'poster',
      'playsinline',
      'controlslist',
      // Embed / iframe
      'allowfullscreen',
      'allow',
      'frameborder',
      'scrolling',
      'sandbox',
      'referrerpolicy',
      'name',
      'loading',
      'title',
      // Tables
      'colspan',
      'rowspan',
      'headers',
      'scope',
      'abbr',
      'cellpadding',
      'cellspacing',
      'border',
      'align',
      'valign',
      // Lists
      'start',
      'reversed',
      'value',
      'type',
      // Text / inline
      'cite',
      'datetime',
      'open',
      'color',
      'face',
      'size',
      // SVG core
      'xmlns',
      'viewBox',
      'fill',
      'stroke',
      'stroke-width',
      'd',
      'cx',
      'cy',
      'r',
      'x',
      'y',
      'x1',
      'y1',
      'x2',
      'y2',
      'rx',
      'ry',
      'points',
      'transform',
      'opacity',
      'clip-path',
      'font-size',
      'text-anchor',
      'dominant-baseline',
      // Misc
      'name',
      'shape',
      'coords',
      'media',
      'wrap',
    ],
    ALLOWED_TAGS: [
      // Structure
      'div',
      'section',
      'article',
      'aside',
      'header',
      'footer',
      'main',
      'nav',
      'figure',
      'figcaption',
      'details',
      'summary',
      // Headings
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      // Text inline
      'p',
      'span',
      'a',
      'abbr',
      'acronym',
      'address',
      'cite',
      'code',
      'dfn',
      'em',
      'kbd',
      'mark',
      'q',
      'samp',
      'small',
      'sub',
      'sup',
      'time',
      'var',
      'bdi',
      'bdo',
      'wbr',
      'nobr',
      // Text formatting
      'b',
      'i',
      'u',
      's',
      'strong',
      'del',
      'ins',
      'strike',
      'tt',
      'big',
      'center',
      'pre',
      'blockquote',
      // Lists
      'ul',
      'ol',
      'li',
      'dl',
      'dt',
      'dd',
      'dir',
      'menu',
      'menuitem',
      // Tables
      'table',
      'thead',
      'tbody',
      'tfoot',
      'tr',
      'th',
      'td',
      'caption',
      'col',
      'colgroup',
      // Media
      'img',
      'video',
      'audio',
      'source',
      'track',
      'picture',
      'canvas',
      // Svg
      'svg',
      'path',
      'circle',
      'ellipse',
      'line',
      'rect',
      'polyline',
      'polygon',
      'g',
      'defs',
      'symbol',
      'use',
      'text',
      'tspan',
      // Embed
      'iframe',
      // Form display (read-only context)
      'label',
      'legend',
      'output',
      'meter',
      'progress',
      // Misc safe
      'br',
      'hr',
      'ruby',
      'rt',
      'rp',
      'hgroup',
      'font',
    ],
    ALLOW_DATA_ATTR: true,
  })
}
